"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var SSLSealComponent = (function () {
    function SSLSealComponent() {
        this.sslSeal = S3_URL + "/dist/client/assets/img/rapid.gif";
    }
    return SSLSealComponent;
}());
SSLSealComponent = __decorate([
    core_1.Component({
        selector: 'ssl-seal',
        styles: [require('./ssl-seal.component.css')],
        template: "\n  <div class=\"seal sp\">\n    <p><img [src]=\"sslSeal\"><span>{{ 'PAYMENT.SSL' | translate }}</span></p>\n  </div>\n"
    }),
    __metadata("design:paramtypes", [])
], SSLSealComponent);
exports.SSLSealComponent = SSLSealComponent;
